@if (!dynamicPanel) {
<atx-media
  [media]="media"
  [videoPlayerProps]="videoPlayerProps"
  objectFit="cover"
></atx-media>
@if (tile.title || tile.subtitle) {
<div
  class="titles"
  [ngStyle]="style"
  [ngClass]="tile.style?.position || 'center'"
>
  @if (tile.title) {
  <h2>{{ tile.title }}</h2>
  } @if (tile.subtitle) {
  <a class="d-inline-block pt-1 px-2">{{ tile.subtitle }}</a>
  }
</div>
} } @if (dynamicPanel) {
<epc-dynamic-collections-outlet
  [items]="panelDefinition"
  (event)="onEvent($event)"
  class="w-100 h-100"
>
</epc-dynamic-collections-outlet>
} @if (isClickable) {
<atx-anchor
  [href]="routeProps.href || routeProps.external"
  [newTab]="!routeProps.href && routeProps.external"
  [routerLink]="routeProps.routerLink"
  [queryParams]="routeProps.queryParams"
  (linkClick)="onTileClick()"
>
</atx-anchor>
}
